import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import { useOrganization } from '@/pages/organizations/detail'
import OrganizationSetModuleDetailPage from '@/pages/organizations/detail/sets/detail/modules/detail'
import { find } from 'lodash'

export const Route = createFileRoute('/app/organizations/$organizationId/sets/$setId/modules/$moduleId')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { setId, moduleId } = Route.useParams()
  const { organization, assessments, responses, userCanInviteUser, userCanViewAssessments } = useOrganization()

  const assessment = find(assessments, (_a) => Number(_a.id) === Number(setId))

  if (!assessment) return null

  return (
    <OrganizationSetModuleDetailPage
      organization={organization}
      assessment={assessment}
      moduleId={parseInt(moduleId, 10)}
      responses={responses}
      userCanInviteUser={userCanInviteUser}
      userCanViewAssessments={userCanViewAssessments}
    />
  )
}
